import {generateRandomId} from '@/utils';

import {IMAGE_DURATION_DEFAULT} from '@/mixins/imageDuration';

/**
 * Represent data needed to upload a file in addition to user-chosen metadata.
 *
 * Only some fields are required on construction:
 *
 *   - file
 *   - groupId
 *   - isAudio
 *   - isImage
 *   - isVideo
 *
 * Everything else is populated later when information becomes available
 * e.g. via loadedmetadata event or as the User interacts with the
 * widgets.
 *
 * Also contains a reference to the widget visualizing the file, so we
 * can e.g. update progress indicators.
 */
export class Uploadable {
  constructor({
    file,
    groupId,
    isAudio,
    isImage,
    isVideo,
    bundleMainTvSpotId = null,
    categoryId = null,
    /**
     * Optional. A list of target TVFormat objects.
     *
     * Must be passed when a non-conforming video is uploaded. Can be
     * passed to force a different or create additional output formats.
     */
    chosenTVFormats = [],
    /**
     * Optional. Used for image only (duration of resulting video).
     */
    duration = IMAGE_DURATION_DEFAULT,
    hardExpire = null,
    hardStart = null,
    ref = null,
    /**
     * Optional list of File|Blob to be bundled along the main file.
     *
     * We support video and image files for this.
     *
     * The idea is that file will be uploaded first, then the sub-files
     * afterwards, assigning the file bundle_id on upload so they end
     * up in the same TVSpotBundle (if possible).
     *
     */
    subContentFiles = [],
    tags = [],
    tagEntriesCanBeDeactivated = true,
    title = null,
  }) {
    this.uuid = generateRandomId();

    // Required
    this.file = file;
    this.isAudio = isAudio;
    this.isImage = isImage;
    this.isVideo = isVideo;

    // Optional
    this.bundleMainTvSpotId = bundleMainTvSpotId;
    this.categoryId = categoryId;
    this.chosenTVFormats = chosenTVFormats;
    this.duration = duration;
    this.groupId = groupId;
    this.hardExpire = hardExpire;
    this.hardStart = hardStart;
    this.ref = ref;
    this.subContentFiles = subContentFiles;
    this.tags = tags;
    this.tagEntriesCanBeDeactivated = tagEntriesCanBeDeactivated;
    this.title = title;
  }
}



// WEBPACK FOOTER //
// ./src/uploadable.js